import React, { memo, useRef } from "react";
import { serverResponse } from "../../../../util/fakeServer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
};
const GalleryModal = ({ gallery }) => {
  const slickRef = useRef();
  const listImages = gallery.map((element, key) => (
    <div key={key}>
      <img
        style={{
          maxHeight: "325px",
          maxWidth: "325px"
        }}
        loading="lazy"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = `${serverResponse.config.clientIcon}`;
        }}
        src={
          element.image_file
            ? element.image_file + "?v=" + serverResponse.config.version
            : element
        }
        alt="img"
      />
    </div>
  ));
  return (
    <div className="row">
      <div className="col-12 col-lg-10 m-auto">
        {gallery.length > 1 && (
          <span
            onClick={() => {
              slickRef.current.slickPrev();
            }}
            className="arrowModal prev d-none d-lg-inline-block"
          />
        )}
        <Slider ref={slickRef} {...settings}>
          {listImages}
        </Slider>
        {gallery.length > 1 && (
          <span
            onClick={() => {
              slickRef.current.slickNext();
            }}
            className="arrowModal next d-none d-lg-inline-block"
          />
        )}
      </div>
    </div>
  );
};

export default memo(GalleryModal);
